var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMugTea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 320H442.381C509.209 320 568.955 271.219 575.385 204.701C582.762 128.385 522.814 64 448 64H48C39.199 64 32 71.199 32 80V352C32 405.02 74.98 448 128 448H320C373.02 448 416 405.02 416 352V320ZM416 112H448C492.125 112 528 147.875 528 192S492.125 272 448 272H416V112ZM368 352C368 378.4 346.4 400 320 400H128C101.6 400 80 378.4 80 352V112H152V152L121.373 182.627C115.371 188.629 112 196.768 112 205.254V256C112 273.672 126.326 288 144 288H192C209.674 288 224 273.672 224 256V205.254C224 196.768 220.629 188.629 214.627 182.627L184 152V112H368V352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugTea);
export default __webpack_public_path__ + "static/media/mug-tea.c1de3cec0445ad66dda62b7497b4457e.svg";
export { ForwardRef as ReactComponent };